export const steps = [
  {
    title: "Quick solutions",
    description:
      "Fawtech delivers rapid, efficient solutions tailored to client needs, minimizing downtime and maximizing productivity.",
  },
  {
    title: "Strategic planning",
    description:
      "Fawtech aligns business goals with actionable strategies to drive long-term success and competitive advantage.",
  },
  {
    title: "Scalable growth",
    description:
      "Fawtech builds adaptable systems that support sustained expansion without compromising performance or quality.",
  },
];

export const chartData = [
  { year: 2023, value: 10, color: "from-gray-300 to-blue-200" },
  { year: 2024, value: 25, color: "from-blue-500 to-blue-300" },
  { year: 2025, value: 39, color: "from-blue-600 to-blue-500" },
  { year: "2026-2030", value: 95, color: "from-blue-600 to-blue-950" },
];
